import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {


  constructor() {
  }

  setItem(key: string, value: any) {
    localStorage.setItem(`${environment.common.storageKeys.appPrefix}-${key}`, JSON.stringify(value));
  }

  getItem(key: string) {
    return JSON.parse(localStorage.getItem(`${environment.common.storageKeys.appPrefix}-${key}`));
  }

  removeItem(key: string) {
    localStorage.removeItem(`${environment.common.storageKeys.appPrefix}-${key}`);
  }
}
